import _ from "underscore";
import SimpleCheckboxNodeRenderer from "../tree/SimpleCheckboxNodeRenderer";
import UserNameFormat from "../../util/UserNameFormat";
import {escapeHtmlSymbols, concatStr} from "../../atUtils";

export default function UserNodeRenderer( tree, selectorFilter, selectionHelper )
{
    SimpleCheckboxNodeRenderer.call(this, tree, selectorFilter, selectionHelper);
}

UserNodeRenderer.prototype = _.create(SimpleCheckboxNodeRenderer.prototype);

UserNodeRenderer.prototype.isNeedToPushDisabledClass = function(treeNode)
{
    return !treeNode.getValue().isActive();
};

UserNodeRenderer.prototype.generateLabel = function ( treeNode, labelEl )
{
    var user = treeNode.getValue();

    var hlFirstName = this.selectorFilter.highlightTokens( user.firstName );
    var hlLastName = this.selectorFilter.highlightTokens( user.lastName );

    var result = UserNameFormat.formatLFM( hlFirstName, hlLastName, escapeHtmlSymbols( user.middleName ) );

    result = concatStr(result, this.selectionHelper.getListDescriptionItemStatus(user), " ");

    labelEl.innerHTML = result;

    labelEl.title = this.getTitle(treeNode.getValue());
};

UserNodeRenderer.prototype.getTitle = function(user) {
    return user.formatNameLFM();
};

UserNodeRenderer.prototype.getNodeClasses = function ( treeNode )
{
    var classes = SimpleCheckboxNodeRenderer.prototype.getNodeClasses.call(this, treeNode);
    if (!treeNode.getValue().isRequiresTTApproval)
    {
        classes.push("autoApproved");
    }
    return classes;
};


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/userSelector/UserNodeRenderer.js